import { Button } from "@material-ui/core";
import React, { useState,useEffect,useCallback } from "react";
import StudentSidebar from "../../../common/Sidebar/StudentSideBar";
const u = JSON.parse(localStorage.getItem('user'));
function StudentSessions() {
  const [allVideo, setAllVideo] = useState(true);
  // const [isLive, setLive] = useState(false);
  // const [selectedFile, setSelectedFile] = useState(null);
  // const [data, setData] = useState("");
  const [educators,setEdu] = useState([]);
  const [videoData, setVideoData] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const getVideos=useCallback(async ()=>{
    console.log("in getVideo");
    setLoading(true);
    
    setLoading(false);
    console.log(u);
    //setEdu(u.educator_assigned);
    console.log(educators)
    if(!isLoading){
      setEdu(u?.educator_assigned);
    }
    for(var i=0;i<educators.length;i++){
      console.log(educators[i]['email']);
      await fetch("https://edtechv.herokuapp.com/api/usersessions",{
        method: "post",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify({
            email: educators[i]['email'],
            educator: "true",
            upcoming: "true"
        })
      })
    .then((response)=>response.json())
    .then((videos)=>{
        console.log(videos);
        setVideoData((oldArray) => [...oldArray, videos]);
    })
    console.log(videoData);
    }
  },[])
  

  useEffect(()=>{
    console.log('In use Effect');  

    getVideos();
},[]); 
  
  const videoes = [
    {
      id: "61ed3d946a3a6beeb446fcf3",
      title: "Introduction to DSA",
      time: "18:00",
      date: "2022-01-23",
      subject: "Computer Graphics" 
    },
    {
      id: "3nkg624mu4egui534ngq2ng4",
      title: "Introduction to CI/CD",
      time: "21:00",
      date: "2022-01-23",
      subject: "DevOps",
    }
  ]
  const AllVideos = () => {
    //console.log(videoData);
    return (
      <div className="all-videos-t" style={{height:"100vh"}}>
        <div className="teach-daily-videos">
          {
            videoes.map((ele,i)=>{ 
                var link = "https://edtechv.netlify.app/call/"+ele.id;

            return(
              <div className='daily-videos' key={i}  style={{backgroundColor:"#E9F2FF",margin:"20px", padding:"15px"}}>
                {/* <img src='https://i.ytimg.com/vi/1xj0MC2IuDU/maxresdefault.jpg' alt="" style={{height:"30vh",width:"10vw"}}/> */}
                <div>
                    <div className='daily-videos-l'>
                    <h2>{ele?.title}</h2>
                    <p>{ele?.subject}</p>
                    <p><a href={link}>Link to Class</a></p>
                    </div>
                    <div>
                        <p>{ele?.date}</p>
                        <p>{ele?.time}</p>
                    </div>
                </div>
            </div>
            )
            })
          }
        </div>
        
      </div>
    );
  };
  // const AddVideos=()=>{
  //   return (
  //     <div>
  //       <TextField/>
  //     </div>
  //   )
  // }
  return (
    <div className="educator-videos">
      <StudentSidebar />
      <div className="teach-vid-main">
        <h1>Your Videos</h1>
        <Button
          onClick={() => setAllVideo(true)}
          style={{
            backgroundColor: `${
              allVideo ? "rgb(223, 240, 246)" : "rgb(234, 230, 230)"
            }`,
          }}
        >
          All Videos
        </Button>
        <AllVideos />
      </div>
    </div>
  );
}

export default StudentSessions;
